import {
  message,
  Modal,
  PageHeader,
  Spin,
  Select,
  Row,
  Col,
  Space,
  Popconfirm,
  Tooltip,
  Typography,
  Switch,
  Input,
  Button,
  Checkbox
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  SelectItem,
  InputNumberItem,
  dineroDisabledMask,
  round2Decimals,
  ButtonItem,
  round6Decimals,
  ErrorItem,
  DatePickerItem,
  InputItem,
  TextAreaItem,
  ModalItem,
  SwitchItem,
  DisponibilidadInsumoModal
} from "../../../../Components/Items";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";
import InfoCard from "../../../../Components/InfoCard";
import FilaInsumoOrdenDeCompra from "../../../../Components/FilaInsumoOrdenDeCompra";
import intentarAprobarOrdenDeCompra from "../../../../Utils/intentarAprobarOrdenDeCompra";
import { calcularTotalesOC, grupoFamiliaDeFila } from "../../../../Utils/OrdenDeCompra.utils";
import {
  aplicarDescuentoBaseAFila,
  costoParaDescuentoProveedor,
  normalizarDescuentoFila,
  sincronizarDescuentoFila,
} from "../../../../Utils/descuentoEscuela";
import EncabezadoFamiliaOC from "../../../../Components/EncabezadoFamiliaOC";
import { PlusOutlined, PrinterOutlined, SearchOutlined, InfoCircleOutlined, EnvironmentOutlined, CarOutlined, UserOutlined, PhoneFilled } from "@ant-design/icons";
import ElegirTipoDeProveedor from "../../Proveedores/ElegirTipoDeProveedor/ElegirTipoDeProveedor";
import moment from "moment";
import ElegirObservaciones from "../../Ventas/ElegirObservaciones/ElegirObservaciones";
import AsignarInsumo from "../AsginarInsumo/AsignarInsumo";
import ModalVerRequisicion from "../../Requisiciones/ModalVerRequisicion/ModalVerRequisicion";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import separacionInsumosPdf from "../../../../Pdf/separacionInsumosPdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;

class EditarOrdenDeCompra extends Component {
  formRef = React.createRef();
  state = {
    modalDisponibilidadVisible: false,
    insumoSeleccionadoDisponibilidad: { id: null, nombre: '' },
    loading: false,
    objetoProveedores: null,
    todasProveedores: null,
    objetoProyectos: null,
    todasProyectos: null,
    objetoInsumos: (
      <Option disabled value={0} key={0}>
        Seleccione un proveedor primero
      </Option>
    ),
    impuestos: [],
    modalElegirTipoDeProveedor: false,
    modalElegirTipoDeProveedorId: null,
    modalElegirTipoDeProveedorNombre: null,
    modalObservaciones: false,
    modalObservacionesIndex: null,
    modalObservacionesObservaciones: null,
    modalObservacionesObservacionesPasadas: null,
    modalObservacionesObservacionesXml: null,
    numeroOrdenDeCompra: "",
    serieOrdenCompra: null,
    requisicion: false,
    insumoIniciales: [],
    modificadaRequisicion: false,
    proveedorExtranjero: false,
    proveedorId: null,
    modalAsignarInsumoVisible: false,
    proveedorSeleccionado: null,
    requisicionesAdicionales: [],
    mostrarDetalles: true,
    verInsumosComoSistema: !!this.props.verComoSistemaOCPorDefecto,
    // Agrupa la tabla de insumos por familia con encabezados colapsables. Es
    // sólo una vista: NO reordena el arreglo `insumos`, así que el orden que se
    // guarda y se imprime es el de captura.
    agruparPorFamilia: false,
    enviarAprobacionAutomatica: true,
    objetoUsosDeCFDI: null,
    objetoFormasDePago: null,
    todasFormasDePago: null,
    // Para la barra de busqueda
    busquedaInsumo: "",
    insumoResaltado: null,
    autoGuardarActivo : false,
    proveedorIdActual: null, 
    nombreProveedorActual: null
  };
  componentDidMount() {
    this.consultarTodo();
  }

  abrirDisponibilidad = (insumoId, nombre, proyectoId) => {
    this.setState({ modalDisponibilidadVisible: true, insumoSeleccionadoDisponibilidad: { id: insumoId, nombre, proyectoId } });
  };

  cerrarDisponibilidad = () => {
    this.setState({ modalDisponibilidadVisible: false });
  };

  promisedSetState = (newState) =>
    new Promise((resolve) => this.setState(newState, resolve));

  async consultarTodo() {
    this.setState({ loading: true });

    const [res, resCatalogos] = await Promise.all([
      axios.post(
        "ordenesdecompra/datosOrdenDeCompra",
        { empresaId: this.props.empresaId, ordenId: this.props.location.state.id },
        { headers: this.props.headersToken }
      ),
      axios.post(
        "ordenesdecompra/selectDatosParaOrdenDeCompra",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ),
    ]);

    if (resCatalogos.data.usosDeCFDI) {
      this.setState({
        objetoUsosDeCFDI: resCatalogos.data.usosDeCFDI.map((value) => (
          <Option value={value._id} key={value._id}>
            {value.c_UsoCFDI + " - " + value.descripcion}
          </Option>
        )),
      });
    }
    if (resCatalogos.data.formasDePago) {
      this.setState({
        todasFormasDePago: resCatalogos.data.formasDePago,
        objetoFormasDePago: resCatalogos.data.formasDePago.map((value) => (
          <Option value={value._id} key={value._id}>
            {value.c_FormaPago + " - " + value.descripcion}
          </Option>
        )),
      });
    }

    if (res.data.success === 2) {
          if (res.data.ordenDeCompra.requisicion) {
            message.info(
              "Solo se pueden editar ciertos datos, ya que proviene de una requisicion previo"
            );
          }
          const ordenData = res.data.ordenDeCompra;
          this.setState(
            {
              datosOrdenDeCompra: res.data.ordenDeCompra,
              numeroOrdenDeCompra: res.data.ordenDeCompra.numero,
              serieOrdenCompra: res.data.ordenDeCompra.serieOrdenCompra,
              requisicion: res.data.ordenDeCompra.requisicion,
              todasMonedas: res.data.monedas,
              objetoMonedas: res.data.monedas.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre + " - " + value.abreviacion}
                  </Option>
                );
              }),
              todasProveedores: res.data.proveedores,
              objetoProveedores: res.data.proveedores.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.stringBuscar}
                  </Option>
                );
              }),
              todasProyectos: res.data.proyectos,
              objetoProyectos: res.data.proyectos.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
              objetoInsumos: res.data.insumos.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.stringBuscar}
                  </Option>
                );
              }),
              insumosIniciales: res.data.ordenDeCompra.insumos,
              requisicionesAdicionales: res.data.requisicionesAdicionales,
            },
            () => {
              this.formRef.current.setFieldsValue({
                ...res.data.ordenDeCompra,
                fechaEntrega: res.data.ordenDeCompra.fechaEntrega ? moment(res.data.ordenDeCompra.fechaEntrega) : null,
                insumos: (res.data.ordenDeCompra.insumos || []).map((valueInsumo) => {
                  const fila = {
                    ...valueInsumo,
                    fechaEntrega: valueInsumo.fechaEntrega ? moment(valueInsumo.fechaEntrega) : null,
                  };
                  // Complemento Escuela: una O/C sin desglose muestra su descuento como adicional.
                  return this.props.escuela ? normalizarDescuentoFila(fila) : fila;
                }),
              });
              const proveedor = res.data.proveedores.find(
                (valueP) =>
                  valueP?._id?.toString() ===
                  res.data?.ordenDeCompra?.proveedorId?.toString()
              );
              this.setState({
                proveedorExtranjero: proveedor?.proveedorExtranjero || false,
                proveedorId: proveedor?._id || null,
                proveedorSeleccionado: proveedor || null,
              });
              
              const proyectoActivo = res.data.proyectos.find(p => p._id === ordenData.proyectoId);
        
              if (proyectoActivo && proyectoActivo.subProyectos?.length > 0) {
                  this.setState({
                      proyectosConSubproyectos: true,
                      objetoSubproyectos: proyectoActivo.subProyectos.map(sp => (
                          <Option key={sp._id} value={sp._id}>
                              {sp.codigo + " - " + sp.nombre}
                          </Option>
                      ))
                  });
              }
    //
            }
          );
        } else {
          message.error(
            "Error no se encontro informacion de la orden de compra"
          );
        }

    await this.setState({ loading: false });
  }
  atras() {
    this.props.history.goBack();
  }

  compararInsumos(insumoIniciales, insumosActuales) {
    const mapInicial = new Map(
      insumoIniciales.map((i) => [i.insumoId?.toString(), i])
    );
    const mapActual = new Map(
      insumosActuales.map((i) => [i.insumoId?.toString(), i])
    );

    const quitados = [];
    const agregados = [];

    // Revisa quitados o modificados
    for (const [id, inicial] of mapInicial.entries()) {
      if (!mapActual.has(id)) {
        quitados.push({
          insumoId: id,
          cantidad: inicial.cantidad,
          insumoSinRequisicion: inicial.insumoSinRequisicion,
        }); // se quitó todo
      } else {
        const actual = mapActual.get(id);
        const diff = actual.cantidad - inicial.cantidad;
        if (diff > 0) {
          agregados.push({
            insumoId: id,
            cantidad: diff,
            insumoSinRequisicion: inicial.insumoSinRequisicion,
          }); // se agregaron unidades
        } else if (diff < 0) {
          quitados.push({
            insumoId: id,
            cantidad: Math.abs(diff),
            insumoSinRequisicion: inicial.insumoSinRequisicion,
          }); // se quitaron unidades
        }
      }
    }

    // Revisa nuevos
    for (const [id, actual] of mapActual.entries()) {
      if (!mapInicial.has(id)) {
        agregados.push({ insumoId: id, cantidad: actual.cantidad }); // insumo totalmente nuevo
      }
    }

    return { quitados, agregados };
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values, isAutoSave = false) {
    if (!isAutoSave) {
      this.setState({ loading: true });
    }
    const {
      subtotal,
      total,
      cuentasProveedor,
      totalPagar,
      arrayImpuestos,
      arrayRetenciones,
    } = calcularTotalesOC(values.insumos, { ignorarIncompletos: false });
    axios
      .post(
        "ordenesdecompra/editarOrdenDeCompra",
        {
          ...values,
          empresaId: this.props.empresaId,
          ordenId: this.props.location.state.id,
          total,
          subtotal,
          cuentasProveedor,
          totalPagar,
          arrayImpuestos,
          arrayRetenciones,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          if(isAutoSave){
            message.success("Progreso guardado automáticamente");
          }else{
            message.success(
              res.data.message || "Se ha editado una orden de compra"
            );
            if (this.props.autorizacionesRapidas && this.state.enviarAprobacionAutomatica) {
              intentarAprobarOrdenDeCompra({
                ordenId: this.props.location.state.id,
                empresaId: this.props.empresaId,
                headersToken: this.props.headersToken,
                folio: (this.state.serieOrdenCompra ? this.state.serieOrdenCompra + " - " : "") + this.state.numeroOrdenDeCompra,
                monto: total,
              });
            }
            this.formRef.current.resetFields();
            this.atras();
          }
        } else if (res.data.success === 1) {
          message.error(res.data.message || "No se puede editar la orden de compra");
        } else {
          message.error("Hubo un error y la orden de compra no se edito");
        }
      });
  }

  // Escribe una sola fila de "insumos" dándole una identidad nueva solo a esa fila
  // (las demás conservan su referencia), para que los shouldUpdate acotados por fila
  // puedan detectar el cambio. No mutar el array/objeto que ya viene mutado desde afuera:
  // aquí solo se hace la copia final antes de escribir al store.
  aplicarFila(key, arrayValue) {
    const nuevoArray = arrayValue.slice();
    nuevoArray[key] = { ...arrayValue[key] };
    this.formRef.current.setFields([{ name: "insumos", value: nuevoArray }]);
  }

  // Cálculo puro de precioUnitarioConImpuestos/subtotal/impuestos/total/retenciones
  // para una fila, dado el insumo ya elegido (fila.insumoCompleto). No muta `fila`,
  // regresa un objeto nuevo (o la misma referencia si no hay insumo, para no romper
  // la identidad de filas vacías). Extraído de onChangePrecioCantidadDescuento para
  // poder recalcular varias filas de un jalón (ver onChangeProveedor).
  calcularCamposFila(fila, proveedorId) {
    const insumo = fila?.insumoCompleto;
    if (!insumo) return fila;

    const nuevaFila = { ...fila };
    const precioUnitario = Number(nuevaFila.precioUnitario);

    let totalImpuestosPrecioSinImpuestos = 0;
    if (!this.state.proveedorExtranjero) {
      insumo.impuestos.map((valueImpuesto) => {
        let totalImpuesto;
        if (valueImpuesto.tasaCuota === 1) {
          totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
        } else if (valueImpuesto.tasaCuota === 2) {
          totalImpuesto =
            (precioUnitario + totalImpuestosPrecioSinImpuestos) *
            (valueImpuesto.monto / 100);
        } else if (valueImpuesto.tasaCuota === 3) {
          totalImpuesto = valueImpuesto.monto;
        } else if (valueImpuesto.tasaCuota === 4) {
          let cantidad = nuevaFila.cantidad;
          if (cantidad) {
            totalImpuesto = (nuevaFila.impuestos || 0) / nuevaFila.cantidad;
          }
        } else if (valueImpuesto.tasaCuota === 5) {
          totalImpuesto = 0;
        }
        totalImpuestosPrecioSinImpuestos += totalImpuesto;
        return null;
      });
    }
    nuevaFila.precioUnitarioConImpuestos = round2Decimals(
      precioUnitario + totalImpuestosPrecioSinImpuestos
    );
    const cantidad = nuevaFila.cantidad;
    const descuento = nuevaFila.descuento || 0;

    if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
      const subtotal = round6Decimals(cantidad * precioUnitario);
      const totalDescuento = round6Decimals(subtotal * (descuento / 100));
      const totalEntrada = round6Decimals(subtotal - totalDescuento);
      nuevaFila.subtotal = totalEntrada;

      let totalImpuestos = 0;
      let arrayImpuestos = [];
      if (!this.state.proveedorExtranjero) {
        arrayImpuestos = insumo.impuestos.map((valueImpuesto) => {
          let totalImpuesto;
          if (valueImpuesto.tasaCuota === 1) {
            totalImpuesto = round6Decimals(
              totalEntrada * (valueImpuesto.monto / 100)
            );
          } else if (valueImpuesto.tasaCuota === 2) {
            totalImpuesto = round6Decimals(
              (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
            );
          } else if (valueImpuesto.tasaCuota === 3) {
            totalImpuesto = round6Decimals(cantidad * valueImpuesto.monto);
          } else if (valueImpuesto.tasaCuota === 4) {
            totalImpuesto = round6Decimals(nuevaFila.impuestos);
          } else if (valueImpuesto.tasaCuota === 5) {
            totalImpuesto = 0;
          }
          totalImpuestos += totalImpuesto;
          return {
            descripcionFactura: valueImpuesto.descripcionFactura,
            totalImpuestos: totalImpuesto,
          };
        });
      }
      nuevaFila.impuestos = totalImpuestos;
      nuevaFila.arrayImpuestos = arrayImpuestos;
      const total = round2Decimals(nuevaFila.subtotal + totalImpuestos);
      nuevaFila.total = total;

      if (proveedorId) {
        const proveedor = this.state.todasProveedores.find(
          (valueP) => valueP._id === proveedorId
        );
        let totalRetenciones = 0;
        let arrayRetenciones = [];

        proveedor.retenciones.map((valueRetencion) => {
          let totalRetencion;
          if (valueRetencion.tasaCuota === 1) {
            totalRetencion = round6Decimals(
              totalEntrada * (valueRetencion.monto / 100)
            );
          } else if (valueRetencion.tasaCuota === 2) {
            totalRetencion = round6Decimals(
              (totalEntrada + totalRetenciones) * (valueRetencion.monto / 100)
            );
          }
          totalRetenciones += totalRetencion;
          arrayRetenciones.push({
            descripcionFactura: valueRetencion.descripcionFactura,
            totalRetenciones: totalRetencion,
          });
          return null;
        });

        if (!this.state.proveedorExtranjero) {
          insumo.retenciones.map((valueRetencion) => {
            if (
              (valueRetencion.aplicaCompra === 1 &&
                proveedor.persona === false) ||
              (valueRetencion.aplicaCompra === 2 &&
                proveedor.persona === true) ||
              valueRetencion.aplicaCompra === 3
            ) {
              let totalRetencion;
              if (valueRetencion.tasaCuota === 1) {
                totalRetencion = round6Decimals(
                  totalEntrada * (valueRetencion.monto / 100)
                );
              } else if (valueRetencion.tasaCuota === 2) {
                totalRetencion = round6Decimals(
                  (totalEntrada + totalRetenciones) *
                    (valueRetencion.monto / 100)
                );
              }
              totalRetenciones += totalRetencion;
              arrayRetenciones.push({
                descripcionFactura: valueRetencion.descripcionFactura,
                totalRetenciones: totalRetencion,
              });
            }
            return null;
          });
        }
        nuevaFila.retenciones = totalRetenciones;
        nuevaFila.arrayRetenciones = arrayRetenciones;
      }
    }

    return nuevaFila;
  }

  async onChangeInsumo(value, key, insumoSeleccionado) {
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    let proveedorId = await this.formRef.current.getFieldValue("proveedorId");
    
    const insumo = insumoSeleccionado; 

    if (!insumo) return;
    arrayValue[key].insumoCompleto = insumo; 

    const precioAnterior = arrayValue.find(
      (item, idx) => idx !== key && String(item?.insumoId) === String(value) && item?.precioUnitario
    )?.precioUnitario;
    arrayValue[key].precioUnitario = precioAnterior || insumo.costo;

    // Complemento Escuela: el renglon trae el descuento predeterminado del
    // proveedor. Con descuento se precarga el costo bruto: el de la relacion ya
    // quedo neto del descuento de la ultima compra y se descontaria dos veces.
    if (this.props.escuela) {
      const descuentoProveedor = this.descuentoPredeterminadoProveedor();
      aplicarDescuentoBaseAFila(arrayValue[key], descuentoProveedor);
      if (descuentoProveedor > 0 && !precioAnterior) {
        arrayValue[key].precioUnitario = costoParaDescuentoProveedor(insumo);
      }
    }

    const precioUnitario = Number(arrayValue[key].precioUnitario);

    let totalImpuestosPrecioSinImpuestos = 0;
    if (!this.state.proveedorExtranjero) {
      insumo.impuestos.map((valueImpuesto) => {
        let totalImpuesto;
        if (valueImpuesto.tasaCuota === 1) {
          totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
        } else if (valueImpuesto.tasaCuota === 2) {
          totalImpuesto =
            (precioUnitario + totalImpuestosPrecioSinImpuestos) *
            (valueImpuesto.monto / 100);
        } else if (valueImpuesto.tasaCuota === 3) {
          totalImpuesto = valueImpuesto.monto;
        } else if (valueImpuesto.tasaCuota === 4) {
          let cantidad = arrayValue[key].cantidad;
          if (cantidad) {
            totalImpuesto =
              (arrayValue[key].impuestos || 0) / arrayValue[key].cantidad;
          }
        } else if (valueImpuesto.tasaCuota === 5) {
          totalImpuesto = 0;
        }
        totalImpuestosPrecioSinImpuestos += totalImpuesto;
        return null;
      });
    }
    arrayValue[key].precioUnitarioConImpuestos = round2Decimals(
      precioUnitario + totalImpuestosPrecioSinImpuestos
    );

    const cantidad = arrayValue[key].cantidad;
    const descuento = arrayValue[key].descuento || 0;

    if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
      //1
      const subtotal = round6Decimals(cantidad * precioUnitario);
      //2
      const totalDescuento = round6Decimals(subtotal * (descuento / 100));
      //3
      const totalEntrada = round6Decimals(subtotal - totalDescuento);
      arrayValue[key].subtotal = totalEntrada;

      let totalImpuestos = 0;
      let arrayImpuestos = [];
      if (!this.state.proveedorExtranjero) {
        arrayImpuestos = insumo.impuestos.map(
          //4
          (valueImpuesto) => {
            let totalImpuesto;
            if (valueImpuesto.tasaCuota === 1) {
              totalImpuesto = round6Decimals(
                totalEntrada * (valueImpuesto.monto / 100)
              );
            } else if (valueImpuesto.tasaCuota === 2) {
              totalImpuesto = round6Decimals(
                (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
              );
            } else if (valueImpuesto.tasaCuota === 3) {
              totalImpuesto = round6Decimals(cantidad * valueImpuesto.monto);
            } else if (valueImpuesto.tasaCuota === 4) {
              totalImpuesto = round6Decimals(arrayValue[key].impuestos);
            } else if (valueImpuesto.tasaCuota === 5) {
              totalImpuesto = 0;
            }
            totalImpuestos += totalImpuesto;
            return {
              descripcionFactura: valueImpuesto.descripcionFactura,
              totalImpuestos: totalImpuesto,
            };
          }
        );
      }
      arrayValue[key].impuestos = totalImpuestos;
      arrayValue[key].arrayImpuestos = arrayImpuestos;
      //5
      const total = round2Decimals(arrayValue[key].subtotal + totalImpuestos);
      arrayValue[key].total = total;

      if (proveedorId) {
        //Consultar proveedor

        const proveedor = this.state.todasProveedores.find(
          (valueP) => valueP._id === proveedorId
        );
        //6
        let totalRetenciones = 0;
        let arrayRetenciones = [];

        proveedor.retenciones.map((valueRetencion) => {
          //7
          let totalRetencion;
          if (valueRetencion.tasaCuota === 1) {
            totalRetencion = round6Decimals(
              totalEntrada * (valueRetencion.monto / 100)
            );
          } else if (valueRetencion.tasaCuota === 2) {
            totalRetencion = round6Decimals(
              (totalEntrada + totalRetenciones) * (valueRetencion.monto / 100)
            );
          }
          totalRetenciones += totalRetencion;
          arrayRetenciones.push({
            descripcionFactura: valueRetencion.descripcionFactura,
            totalRetenciones: totalRetencion,
          });
          return null;
        });

        if (!this.state.proveedorExtranjero) {
          insumo.retenciones.map((valueRetencion) => {
            if (
              (valueRetencion.aplicaCompra === 1 &&
                proveedor.persona === false) ||
              (valueRetencion.aplicaCompra === 2 &&
                proveedor.persona === true) ||
              valueRetencion.aplicaCompra === 3
            ) {
              //7
              let totalRetencion;
              if (valueRetencion.tasaCuota === 1) {
                totalRetencion = round6Decimals(
                  totalEntrada * (valueRetencion.monto / 100)
                );
              } else if (valueRetencion.tasaCuota === 2) {
                totalRetencion = round6Decimals(
                  (totalEntrada + totalRetenciones) *
                  (valueRetencion.monto / 100)
                );
              }
              totalRetenciones += totalRetencion;
              arrayRetenciones.push({
                descripcionFactura: valueRetencion.descripcionFactura,
                totalRetenciones: totalRetencion,
              });
            }
            return null;
          });
        }
        arrayValue[key].retenciones = totalRetenciones;
        arrayValue[key].arrayRetenciones = arrayRetenciones;
      }
    }

    const aplicarValoresInsumo = () => {
      this.aplicarFila(key, arrayValue);
    };

    const monedaOrden = this.formRef.current.getFieldValue("monedaId");
    const monedaInsumo = insumo.monedaId;

    if (monedaInsumo && monedaOrden && String(monedaInsumo) !== String(monedaOrden)) {
      const nombreMoneda = (id) => {
        const moneda = this.state.todasMonedas?.find((valueM) => String(valueM._id) === String(id));
        return moneda ? (moneda.abreviacion || moneda.nombre) : "otra moneda";
      };
      Modal.confirm({
        title: "Moneda distinta a la de la orden",
        content: `Este insumo tiene configurada la moneda ${nombreMoneda(monedaInsumo)} en su relación con este proveedor, pero la orden está en ${nombreMoneda(monedaOrden)}. ¿Deseas agregarlo así de todas formas?`,
        okText: "Agregar de todas formas",
        cancelText: "Cancelar",
        onOk: aplicarValoresInsumo,
        onCancel: () => {
          arrayValue[key].insumoId = undefined;
          arrayValue[key].insumoCompleto = null;
          this.aplicarFila(key, arrayValue);
        },
      });
    } else {
      aplicarValoresInsumo();
    }
  }
  async onChangePrecioCantidadDescuento(value, key) {
    const arrayValue = this.formRef.current.getFieldValue("insumos");
    const proveedorId = this.formRef.current.getFieldValue("proveedorId");

    const { quitados, agregados } = this.compararInsumos(
      this.state.insumosIniciales,
      arrayValue
    );
    const requiereModificarRequisicion =
      quitados.filter((p) => !p.insumoSinRequisicion).length > 0 ||
      agregados.filter((p) => !p.insumoSinRequisicion).length > 0;
    // Comparar contra el valor anterior antes de hacer setState: de lo contrario,
    // cada tecla de cantidad/precio/descuento re-renderiza toda la página (y con
    // ella las 120+ filas), sin importar qué tan bien se acoten los shouldUpdate.
    if (this.state.modificadaRequisicion !== requiereModificarRequisicion) {
      this.setState({ modificadaRequisicion: requiereModificarRequisicion });
    }

    if (!arrayValue[key]?.insumoCompleto) return;

    const nuevaFila = this.calcularCamposFila(arrayValue[key], proveedorId);
    const nuevoArray = arrayValue.slice();
    nuevoArray[key] = nuevaFila;
    this.formRef.current.setFields([{ name: "insumos", value: nuevoArray }]);
  }

  // Complemento Escuela: % predeterminado del proveedor seleccionado.
  descuentoPredeterminadoProveedor = () => {
    const proveedorId = this.formRef.current?.getFieldValue("proveedorId");
    const proveedor = this.state.todasProveedores.find(
      (valueP) => valueP._id?.toString() === proveedorId?.toString()
    );
    return proveedor?.descuentoPredeterminado || 0;
  };

  // Complemento Escuela: Desc. Prov. y Desc. Adic. alimentan `descuento` (su
  // cascada), que es el unico que entra en el calculo.
  onChangeDescuentoEscuela(key) {
    const arrayValue = this.formRef.current.getFieldValue("insumos");
    if (!arrayValue[key]) return;
    const nuevoArray = arrayValue.slice();
    nuevoArray[key] = sincronizarDescuentoFila({ ...arrayValue[key] });
    this.formRef.current.setFields([{ name: "insumos", value: nuevoArray }]);
    this.onChangePrecioCantidadDescuento(undefined, key);
  }

  async onChangePrecioImpuestos(value, key) {
    const arrayValue = this.formRef.current.getFieldValue("insumos");
    const proveedorId = this.formRef.current.getFieldValue("proveedorId");
     const insumo = arrayValue[key]?.insumoCompleto;
    if (!insumo) return;

    const precioUnitarioConImpuestos =
      arrayValue[key].precioUnitarioConImpuestos;

    let totalPorcentajeImpuestos = 1;
    let totalCantidadImpuestos = 0;
    if (!this.state.proveedorExtranjero) {
      insumo.impuestos.map((valueImpuesto) => {
        if (valueImpuesto.tasaCuota === 1) {
          totalPorcentajeImpuestos += valueImpuesto.monto / 100;
        } else if (valueImpuesto.tasaCuota === 2) {
          totalPorcentajeImpuestos +=
            totalPorcentajeImpuestos * (valueImpuesto.monto / 100);
        } else if (valueImpuesto.tasaCuota === 3) {
          totalCantidadImpuestos = valueImpuesto.monto;
        }
        return null;
      });
    }

    const precioUnitario =
      precioUnitarioConImpuestos / totalPorcentajeImpuestos +
      totalCantidadImpuestos;
    arrayValue[key].precioUnitario = precioUnitario;
    const cantidad = arrayValue[key].cantidad;
    const descuento = arrayValue[key].descuento || 0;

    if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
      //1
      const subtotal = round6Decimals(cantidad * precioUnitario);
      //2
      const totalDescuento = round6Decimals(subtotal * (descuento / 100));
      //3
      const totalEntrada = round6Decimals(subtotal - totalDescuento);
      arrayValue[key].subtotal = totalEntrada;

      let totalImpuestos = 0;
      let arrayImpuestos = [];
      if (!this.state.proveedorExtranjero) {
        arrayImpuestos = insumo.impuestos.map(
          //4
          (valueImpuesto) => {
            let totalImpuesto;
            if (valueImpuesto.tasaCuota === 1) {
              totalImpuesto = round6Decimals(
                totalEntrada * (valueImpuesto.monto / 100)
              );
            } else if (valueImpuesto.tasaCuota === 2) {
              totalImpuesto = round6Decimals(
                (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
              );
            } else if (valueImpuesto.tasaCuota === 3) {
              totalImpuesto = round6Decimals(cantidad * valueImpuesto.monto);
            } else if (valueImpuesto.tasaCuota === 4) {
              totalImpuesto = round6Decimals(arrayValue[key].impuestos);
            } else if (valueImpuesto.tasaCuota === 5) {
              totalImpuesto = 0;
            }
            totalImpuestos += totalImpuesto;
            return {
              descripcionFactura: valueImpuesto.descripcionFactura,
              totalImpuestos: totalImpuesto,
            };
          }
        );
      }
      arrayValue[key].impuestos = totalImpuestos;
      arrayValue[key].arrayImpuestos = arrayImpuestos;
      //5
      const total = round2Decimals(arrayValue[key].subtotal + totalImpuestos);
      arrayValue[key].total = total;

      if (proveedorId) {
        //Consultar proveedor

        const proveedor = this.state.todasProveedores.find(
          (valueP) => valueP._id === proveedorId
        );
        //6
        let totalRetenciones = 0;
        let arrayRetenciones = [];

        proveedor.retenciones.map((valueRetencion) => {
          //7
          let totalRetencion;
          if (valueRetencion.tasaCuota === 1) {
            totalRetencion = round6Decimals(
              totalEntrada * (valueRetencion.monto / 100)
            );
          } else if (valueRetencion.tasaCuota === 2) {
            totalRetencion = round6Decimals(
              (totalEntrada + totalRetenciones) * (valueRetencion.monto / 100)
            );
          }
          totalRetenciones += totalRetencion;
          arrayRetenciones.push({
            descripcionFactura: valueRetencion.descripcionFactura,
            totalRetenciones: totalRetencion,
          });
          return null;
        });

        if (!this.state.proveedorExtranjero) {
          insumo.retenciones.map((valueRetencion) => {
            if (
              (valueRetencion.aplicaCompra === 1 &&
                proveedor.persona === false) ||
              (valueRetencion.aplicaCompra === 2 &&
                proveedor.persona === true) ||
              valueRetencion.aplicaCompra === 3
            ) {
              //7
              let totalRetencion;
              if (valueRetencion.tasaCuota === 1) {
                totalRetencion = round6Decimals(
                  totalEntrada * (valueRetencion.monto / 100)
                );
              } else if (valueRetencion.tasaCuota === 2) {
                totalRetencion = round6Decimals(
                  (totalEntrada + totalRetenciones) *
                  (valueRetencion.monto / 100)
                );
              }
              totalRetenciones += totalRetencion;
              arrayRetenciones.push({
                descripcionFactura: valueRetencion.descripcionFactura,
                totalRetenciones: totalRetencion,
              });
            }
            return null;
          });
        }
        arrayValue[key].retenciones = totalRetenciones;
        arrayValue[key].arrayRetenciones = arrayRetenciones;
      }
    }

    this.aplicarFila(key, arrayValue);
  }


  async onChangeProveedor(value, _, dejarInsumos) {
    const proveedor = this.state.todasProveedores.find(
      (valueProv) => valueProv._id === value
    );
    if (!proveedor.tipoProveedorId) {
      const nombre = proveedor.persona
        ? proveedor.razonSocial
        : `${proveedor.nombre} ${proveedor.apellidoPaterno} ${proveedor.apellidoMaterno}`;
      this.abrirElegirTipoDeProveedor(proveedor._id, nombre);
    }
    this.setState({ proveedorSeleccionado: proveedor });
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    const fechaFactura = this.formRef.current.getFieldValue("fechaFactura");
    this.formRef.current.setFieldsValue({
      insumos: dejarInsumos ? arrayValue : [],
      fechaPago: moment(fechaFactura).add(proveedor.diasCredito, "days"),
      diasCredito: proveedor.diasCredito || 0,
      usoDeCfdiId: proveedor.usoDeCfdiId || undefined,
      metodoPago: proveedor.metodoPago || undefined,
      formaDePagoId: proveedor.formaDePagoId || undefined,
    });
    if (proveedor.monedaId) {
      this.aplicarMoneda(proveedor.monedaId);
    }
    //await this.consultarInsumoProveedor(value);

    if (arrayValue?.length > 0 && dejarInsumos) {
      const nuevoArray = arrayValue.map((fila) => this.calcularCamposFila(fila, value));
      this.formRef.current.setFields([{ name: "insumos", value: nuevoArray }]);
    }
    this.setState({
      loading: false,
      proveedorExtranjero: proveedor.proveedorExtranjero || false,
      proveedorId: proveedor._id,
    });
  }
  abrirElegirTipoDeProveedor(id, nombre) {
    this.setState({
      modalElegirTipoDeProveedor: true,
      modalElegirTipoDeProveedorId: id,
      modalElegirTipoDeProveedorNombre: nombre,
    });
  }
  cerrarElegirTipoDeProveedor(elegido) {
    if (!elegido) {
      this.formRef.current.setFieldsValue({ proveedorId: undefined });
    }
    this.consultarTodo();
    this.setState({
      modalElegirTipoDeProveedor: false,
      modalElegirTipoDeProveedorId: null,
      modalElegirTipoDeProveedorNombre: null,
    });
  }
   abrirObservaciones(index, observaciones, observacionesPasadas) {
    const proveedorIdActual = this.formRef.current.getFieldValue('proveedorId');
    const proveedorActual = this.state.todasProveedores.find(p => p._id === proveedorIdActual);
    const nombreProveedorActual = proveedorActual ? (proveedorActual.persona ? proveedorActual.razonSocial : `${proveedorActual.nombre} ${proveedorActual.apellidoPaterno} ${proveedorActual.apellidoMaterno}`) : 'Proveedor Desconocido';
    this.setState({
      modalObservaciones: true,
      modalObservacionesIndex: index,
      modalObservacionesObservaciones: observaciones,
      modalObservacionesObservacionesPasadas: observacionesPasadas,
      proveedorIdActual: proveedorIdActual, 
      nombreProveedorActual: nombreProveedorActual
    });
  }
  cerrarObservaciones(value) {
    const insumos = this.formRef.current.getFieldValue("insumos");
    insumos[this.state.modalObservacionesIndex].observaciones = value;
    this.formRef.current.setFieldsValue({
      insumos: insumos,
    });
    this.setState({
      modalObservaciones: false,
      modalObservacionesIndex: null,
      modalObservacionesObservaciones: null,
      modalObservacionesObservacionesPasadas: null,
      proveedorIdActual: null,
      nombreProveedorActual: null
    });
  }
  aplicarMoneda(value) {
    if (value === "60c7e4396465ad440c41c15a") {
      this.formRef.current.setFieldsValue({ monedaId: value, tipoDeCambio: 1 });
    } else {
      this.formRef.current.setFieldsValue({ monedaId: value });
      this.onChangeMoneda(value);
    }
  }

  onChangeMoneda(value) {
    if (value && value !== "60c7e4396465ad440c41c15a") {
      axios
        .post(
          "tipoDeCambio/obtenerTipoDeCambio",
          {
            monedaId: value,
            empresaId: this.props.empresaId,
          },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success === 2) {
            if (res.data.monedaString && res.data.dia) {
              message.success(
                "Se ha obtenido el tipo de cambio" +
                (res.data.monedaString ? " " + res.data.monedaString : "") +
                (res.data.dia ? " del día " + res.data.dia : "")
              );
            }
            this.formRef.current.setFieldsValue({
              tipoDeCambio: res.data.tipoDeCambio,
            });
          }
        });
    }
  }

  //Quiero que cheque el formulario y que sisi ejecute onFinish con modificarRequisicion: true
  async modificarRequisicion() {
    await this.formRef.current.setFieldsValue({ modificarRequisicion: true });
    this.formRef.current.formRef.current.submit();
  }

  async noModificarRequisicion() {
    await this.formRef.current.setFieldsValue({ modificarRequisicion: false });
    this.formRef.current.formRef.current.submit();
  }

  cambiosInsumosOC() {
    const insumos = this.formRef.current.getFieldValue("insumos");
    const { quitados, agregados } = this.compararInsumos(
      this.state.insumosIniciales,
      insumos
    );
    const requiereModificarRequisicion =
      quitados.filter((p) => !p.insumoSinRequisicion).length > 0 ||
      agregados.filter((p) => !p.insumoSinRequisicion).length > 0;
    if (this.state.modificadaRequisicion !== requiereModificarRequisicion) {
      this.setState({ modificadaRequisicion: requiereModificarRequisicion });
    }
  }

  abrirModalAsignarInsumo = () => {
    this.setState({ modalAsignarInsumoVisible: true });
  };

  cerrarModalAsignarInsumo = (nuevoInsumoRelacionado) => {
    if (nuevoInsumoRelacionado) {
      //this.consultarInsumoProveedor(this.state.proveedorId);
    }
    this.setState({ modalAsignarInsumoVisible: false, loading: false });
  };

  verRequisicionModal(id) {
    this.setState({ modalVerRequisicion: true, modalVerRequisicionId: id });
  }

  cerrarModalVerRequisicion() {
    this.setState({ modalVerRequisicion: false, modalVerRequisicionId: null });
  }

  generarPdfSeparar = () => {
    const doc = separacionInsumosPdf({
      orden: this.state.datosOrdenDeCompra,
      insumos: this.formRef.current?.getFieldValue("insumos") || [],
      catalogoInsumos: this.state.todasInsumos,
      requisiciones: this.state.requisicionesAdicionales,
      simple: !!this.props.separacionInsumosSimpleOC,
      porCliente: !!this.props.separacionInsumosPorClienteOC,
      porDia: !!this.props.separacionInsumosPorDiaOC,
    });

    if (!doc) {
      message.info("No hay insumos para imprimir.");
      return;
    }

    pdfMake.createPdf(doc).getBlob((blob) => {
      if (this.state.pdfSepararUrl) URL.revokeObjectURL(this.state.pdfSepararUrl);
      const url = URL.createObjectURL(blob);
      this.setState({ modalPdfSeparar: true, pdfSepararUrl: url });
    });
  };



  cerrarModalPdfSeparar = () => {
    if (this.state.pdfSepararUrl) {
      URL.revokeObjectURL(this.state.pdfSepararUrl);
    }
    this.setState({ modalPdfSeparar: false, pdfSepararUrl: null });
  };

  onChangeProyecto(value) {
    // const insumos = this.formRef.current.getFieldValue('insumos')

    const proyecto = this.state.todasProyectos?.find(
      (valueP) => valueP._id === value
    );
    if (
      proyecto &&
      Array.isArray(proyecto.subProyectos) &&
      proyecto?.subProyectos?.length > 0
    ) {
      this.setState({
        proyectosConSubproyectos: true,
        objetoSubproyectos: proyecto.subProyectos.map((value) => (
          <Option key={value._id} value={value._id}>
            {value.codigo + " - " + value.nombre}
          </Option>
        )),
       
      });
    }
    else{
      this.setState({
        proyectosConSubproyectos: false,
        objetoSubproyectos: []
      })
    }
    if(proyecto && proyecto.numeracionOrdenesSemana){
      this.setState({numeracionPorSemana: true,});
      this.formRef.current.setFieldsValue({
          numeroSemana: null
        });
    } else {
      this.setState({ numeracionPorSemana: false });
      this.formRef.current.setFieldsValue({ numeroSemana: null });
    }
    // if (Array.isArray(insumos) && insumos.length > 0) {
    //   const nuevosInsumos = insumos.map(insumo => {
    //     if (!insumo.proyectoId) {
    //       insumo.proyectoId = value
    //     }
    //     return insumo
    //   })
    //   this.formRef.current.setFieldsValue({
    //     insumos: nuevosInsumos
    //   })
    // }
  }

  async recargarInsumoEditado(proveedorId, insumoId, arrayKey) {
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "insumos/selectInsumosRelacionesProveedor",
        {
          empresaId: this.props.empresaId,
          proveedorId: proveedorId,
          query: insumoId, 
          skip: 0
        },
        { headers: this.props.headersToken }
      );

      if (res.data.success === 2 && res.data.insumos && res.data.insumos.length > 0) {
        const insumoFresco = res.data.insumos[0];
        
        let arrayValue = this.formRef.current.getFieldValue("insumos");
        
        arrayValue[arrayKey].insumoCompleto = insumoFresco;
        
        arrayValue[arrayKey].precioUnitario = insumoFresco.costo || arrayValue[arrayKey].precioUnitario;
        
        this.formRef.current.setFieldsValue({ insumos: arrayValue });
        
        await this.onChangePrecioCantidadDescuento(arrayValue[arrayKey].precioUnitario, arrayKey);
      }
    } catch (error) {
      console.error("Error recargando el insumo modificado:", error);
    } finally {
      this.setState({ loading: false });
    }
  }

  buscarInsumo = (valor) => {
    this.setState({ busquedaInsumo: valor, insumoResaltado: null });
    if (!valor) return;

    const insumos = this.formRef.current?.getFieldValue("insumos") || [];
    const texto = valor.toLowerCase();
    const index = insumos.findIndex((insumo) => {
      const infoInsumo = insumo.insumoCompleto;
      if (!infoInsumo) return false;
      return (
        infoInsumo.descripcion?.toLowerCase().includes(texto) ||
        infoInsumo.codigo?.toLowerCase().includes(texto) ||
        infoInsumo.clave?.toLowerCase().includes(texto) ||
        infoInsumo.codigoBarras?.toLowerCase().includes(texto)
      );
    });

    if (index === -1) {
      message.warning("No se encontró ningún insumo con ese criterio");
      return;
    }

    this.setState({ insumoResaltado: index });

    const fila = document.getElementById(`insumo-row-${index}`);
    if (fila) {
      fila.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  autoGuardarYAgregar = async (add, params) => {
      try {
        // Validar campos antes de guardar
        await this.formRef.current.validateFields();
        const valoresActuales = this.formRef.current.getFieldsValue();
  
        this.onFinish(valoresActuales, true);
      } catch (errorInfo) {
        message.warning("No se pudo completar el auto guardado.");
      }
      add(params);
    };
  
  renderProyectoCard() {
    return (
      <FormItem
        noStyle
        shouldUpdate={(prev, curr) =>
          prev.proyectoId !== curr.proyectoId || prev.proveedorId !== curr.proveedorId
        }
      >
        {({ getFieldValue }) => {
          const proyectoId = getFieldValue("proyectoId");
          const proveedorId = getFieldValue("proveedorId");
          if (!proyectoId) return null;
          const proyecto = this.state.todasProyectos?.find((value) => value._id === proyectoId);
          const proveedor = proveedorId ? this.state.todasProveedores?.find((value) => value._id === proveedorId) : null;
          if (!proyecto) return null;

          return (
            <Row gutter={[16, 16]}>
              <InfoCard
                title="PROYECTO"
                icon={<InfoCircleOutlined />}
                accentColor="#00BFD6"
                compact
                lg={12}
                sections={[
                  {
                    title: "Información General",
                    icon: <InfoCircleOutlined />,
                    iconColor: "#00BFD6",
                    lg: 12,
                    items: [
                      { label: "Nombre", value: proyecto.nombre || "-" },
                      { label: "Descripción", value: proyecto.descripcion || "-" },
                    ],
                  },
                  {
                    title: proyecto.calle ? "Dirección de envío" : "Vehículo",
                    icon: proyecto.calle ? <EnvironmentOutlined /> : <CarOutlined />,
                    iconColor: "#C9DF00",
                    lg: 12,
                    items: proyecto.calle ? [
                      { label: "Calle", value: proyecto.calle },
                      { label: "Número", value: proyecto.numeroCalle || "-" },
                    ] : [
                      { label: "Marca", value: proyecto.marca || "-" },
                      { label: "Modelo", value: proyecto.modelo || "-" },
                      { label: "Placas", value: proyecto.placas || "-" },
                    ],
                  },
                ]}
              />
              <InfoCard
                title="PROVEEDOR"
                icon={<UserOutlined />}
                accentColor="#00BFD6"
                compact
                lg={12}
                sections={
                  proveedor ? [
                    {
                      title: "Datos Generales",
                      icon: <UserOutlined />,
                      iconColor: "#FF6A0D",
                      lg: 13,
                      items: [
                        {
                          label: "Nombre",
                          value: proveedor.nombre
                            ? `${proveedor.nombre} ${proveedor.apellidoPaterno} ${proveedor.apellidoMaterno}`
                            : proveedor.razonSocial || "-",
                          bold: true,
                        },
                        { label: "RFC", value: proveedor.rfc },
                        { label: "Correo", value: proveedor.correo },
                        { label: "Teléfono", value: proveedor.telefono },
                        { label: "Celular", value: proveedor.celular },
                      ],
                    },
                    {
                      title: "Contacto",
                      icon: <PhoneFilled />,
                      iconColor: "#DB2777",
                      lg: 10,
                      items: [
                        { label: "Contacto",          value: proveedor.nombreContacto   || "-" },
                        { label: "Teléfono",        value: proveedor.telefonoContacto || "-" },
                        { label: "Correo",          value: proveedor.correoContacto   || "-" },
                        { label: "Días de crédito", value: proveedor.diasCredito       ?? "-" },
                      ],
                    },
                  ] : [
                    {
                      items: [{ label: null, value: "Sin proveedor seleccionado", color: "#aaa" }],
                    },
                  ]
                }
              />
            </Row>
          );
        }}
      </FormItem>
    );
  }

  getInsumosColumns() {
    return [
      { title: "#", width: "3%" },
      { title: "Clave",  width: "5%" },
      { title: "Insumo",  width: "17%" },
      { title: "Unidad", width: "5%" },
      { title: "Precio Unitario", width: "9%"  },
      { title: "Precio Unit. c/Imp.",  width: "9%"  },
      { title: "Cant.",   width: "7%"  },
      { title: "F. Entrega", width: "8%" },
      { title: "Req.",    width: "6%"  },
      ...(this.props.escuela ? [{ title: "Desc. Prov.", width: "7%" }] : []),
      { title: this.props.escuela ? "Desc. Adic." : "Descuento",  width: "7%"  },
      { title: "Subtotal / Imp. / Total",  width: "12%" },
      { title: "Acción",   width: "10%" },
    ];
  }

  // funcionesFila y renderInsumoRow: ver comentario equivalente en
  // AgregarOrdenDeCompra.js — deben tener identidad estable para que
  // FilaInsumoOrdenDeCompra (React.memo) pueda descartar filas sin cambios.
  funcionesFila = {
    onChangeInsumo: (value, key, insumo) => this.onChangeInsumo(value, key, insumo),
    onChangePrecioCantidadDescuento: (value, key) => this.onChangePrecioCantidadDescuento(value, key),
    onChangeDescuentoEscuela: (key) => this.onChangeDescuentoEscuela(key),
    onChangePrecioImpuestos: (value, key) => this.onChangePrecioImpuestos(value, key),
    abrirDisponibilidad: this.abrirDisponibilidad,
    abrirObservaciones: (...args) => this.abrirObservaciones(...args),
    recargarInsumoEditado: async (proveedorId, insumoId, arrayKey) => {
      const currentProveedorId = this.formRef.current.getFieldValue("proveedorId");
      await this.recargarInsumoEditado(currentProveedorId, insumoId, arrayKey);
    },
    verRequisicionModal: (id) => this.verRequisicionModal(id),
    cambiosInsumosOC: () => this.cambiosInsumosOC(),
  };

  renderInsumoRow = ({ key, name, restField, arrayKey, remove }) => {
    const insumosValues = this.formRef.current?.getFieldValue("insumos") || [];
    const proyectoId = this.formRef.current?.getFieldValue("proyectoId");
    return (
      <FilaInsumoOrdenDeCompra
        key={key}
        name={name}
        restField={restField}
        arrayKey={arrayKey}
        remove={remove}
        insumosValues={insumosValues}
        modo="editar"
        empresaId={this.props.empresaId}
        headersToken={this.props.headersToken}
        proveedorId={this.state.proveedorId}
        proyectoId={proyectoId}
        verInsumosComoSistema={this.state.verInsumosComoSistema}
        mostrarDetalles={this.state.mostrarDetalles}
        resaltado={this.state.insumoResaltado === arrayKey}
        totalColumnas={this.getInsumosColumns().length}
        requisicionActiva={this.state.requisicion}
        requisicionesAdicionales={this.state.requisicionesAdicionales}
        recargarTrigger={this.state.triggerRecargarInsumos}
        escuela={this.props.escuela}
        funciones={this.funcionesFila}
      />
    );
  };

  // Config de agrupado que consume TabbedDynamicTable. `obtenerGrupo` lee el
  // arreglo del formulario en cada llamada (no lo captura) para que agrupar
  // refleje el insumo que la fila tiene AHORA, no el que tenía al renderizar.
  agrupacionPorFamilia = () => ({
    activa: this.state.agruparPorFamilia,
    obtenerGrupo: (arrayKey) =>
      grupoFamiliaDeFila((this.formRef.current?.getFieldValue("insumos") || [])[arrayKey]),
    renderEncabezado: (props) => <EncabezadoFamiliaOC {...props} listName="insumos" />,
  });

  getObservacionesConfig() {
    return {
      checkboxes: [
        {
          name: "imprimirObservaciones",
          label: "Imprimir Observaciones",
        },
      ],
      totales: (
        <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos !== curr.insumos}>
          {({ getFieldValue }) => {
            const { subtotal, total, cuentasProveedor, arrayImpuestos, arrayRetenciones } =
              calcularTotalesOC(getFieldValue("insumos"));
            return (
              <table className="table" style={{ marginTop: 0, fontSize: "16px" }}>
                <tbody>
                  <tr>
                    <th className="th-totales" style={{ width: "50%", fontSize: "16px" }}>Subtotal</th>
                    <td className="td-totales-right" style={{ width: "50%", fontSize: "16px" }}>
                      {dineroDisabledMask(subtotal)}
                    </td>
                  </tr>
                </tbody>
                {arrayImpuestos.map((valueArray) => (
                  <tbody key={valueArray.descripcionFactura}>
                    <tr>
                      <th className="th-totales" style={{ fontSize: "16px" }}>{valueArray.descripcionFactura}</th>
                      <td className="td-totales-right" style={{ fontSize: "16px" }}>{dineroDisabledMask(valueArray.totalImpuestos)}</td>
                    </tr>
                  </tbody>
                ))}
                <tbody>
                  <tr>
                    <th className="th-totales" style={{ fontSize: "16px" }}>Total</th>
                    <td className="td-totales-right" style={{ fontSize: "16px" }}>
                      {dineroDisabledMask(total)}
                    </td>
                  </tr>
                </tbody>
                {arrayRetenciones.map((value, i) => (
                  <tbody key={i}>
                    <tr>
                      <th className="th-totales" style={{ fontSize: "16px" }}>{value.descripcionFactura}</th>
                      <td className="td-totales-right" style={{ fontSize: "16px" }}>{dineroDisabledMask(value.totalRetenciones)}</td>
                    </tr>
                  </tbody>
                ))}
                <tbody>
                  <tr>
                    <th className="th-totales" style={{ fontSize: "16px" }}>Total a pagar</th>
                    <td className="td-totales-right" style={{ fontSize: "16px" }}>
                      {dineroDisabledMask(total - cuentasProveedor)}
                    </td>
                  </tr>
                </tbody>
              </table>
            );
          }}
        </FormItem>
      ),
    };
  }

  render() {
    const isMobile = window.innerWidth <= 1000;
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title={
            "Editar Orden de Compra " +
            ((this.state.serieOrdenCompra ? this.state.serieOrdenCompra + " - " : "") +
              this.state.numeroOrdenDeCompra)
          }
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={[
            <Row gutter={12} key="extra-row">
              <Col>
                <Space key="auto-save-space" align="center">
                  <span style={{ fontWeight: '500', color: this.state.autoGuardarActivo ? '#52c41a' : 'gray' }}>
                    Auto-guardado {this.state.autoGuardarActivo ? 'Activado' : 'Desactivado'}
                  </span>
                  <SwitchItem
                    checked={this.state.autoGuardarActivo}
                    onChange={(checked) => this.setState({ autoGuardarActivo: checked })}
                  />
                </Space>
              </Col>
              <Col>
                <Space key="extra-actions" align="center">
                  <ButtonItem
                    icon={<PrinterOutlined />}
                    onClick={this.generarPdfSeparar}
                    hotkey="alt+i"
                    petroleo
                  >
                    Imprimir separación
                  </ButtonItem>
                </Space>
              </Col>
            </Row>
          ]}
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="editarOrdenDeCompra"
              layout
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              <FormItem name="modificarRequisicion" hidden>
                <InputItem type="hidden" />
              </FormItem>
              <div style={{ padding: '0 16px', marginBottom: 35 }}>
                {this.renderProyectoCard()}
              </div>
              <GeneralFormLayout
                totalesMaxWidth="30%"
                isMobile={isMobile}
                cards={[
                  {
                    title: "Datos Generales",
                    lg: 18,
                    content: (
                      <Row>
                        <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                          <FormItem label="Proyecto" name="proyectoId" margin required>
                            <SelectItem
                              placeholder="Proyecto"
                              onChange={(value) => this.onChangeProyecto(value)}
                            >
                              {this.state.objetoProyectos}
                            </SelectItem>
                          </FormItem>
                          {this.state.proyectosConSubproyectos && (
                            <FormItem noStyle shouldUpdate={(prev, curr) => prev.proyectoId !== curr.proyectoId}>
                              {({ getFieldValue }) => {
                                let proyectoId = getFieldValue("proyectoId");
                                if (!proyectoId) return null;
                                return (
                                  <FormItem label="Subproyecto" name="subProyectoId" margin>
                                    <SelectItem placeholder="Subproyecto" allowClear>
                                      {this.state.objetoSubproyectos}
                                    </SelectItem>
                                  </FormItem>
                                );
                              }}
                            </FormItem>
                          )}
                          <FormItem name="destino" label="Destino" max={50} margin pattern>
                            <InputItem placeholder="Domicilio, Ocurre.." />
                          </FormItem>
                          <FormItem name="embarque" label="Embarque" max={50} margin pattern>
                            <InputItem placeholder="Embarque" />
                          </FormItem>
                          <FormItem pattern name="atencion" label="Atención a" margin tooltip="Indica a quién dirigir este documento.">
                            <InputItem />
                          </FormItem>
                          <FormItem name="usoDeCfdiId" label="Uso de CFDI" margin>
                            <SelectItem placeholder="Uso de CFDI" allowClear>
                              {this.state.objetoUsosDeCFDI}
                            </SelectItem>
                          </FormItem>
                          <FormItem name="metodoPago" label="Método de Pago" margin>
                            <SelectItem
                              placeholder="Método de Pago"
                              allowClear
                              onChange={() => this.formRef.current.setFieldsValue({ formaDePagoId: undefined })}
                            >
                              <Option value={1}>PUE - Pago en Una sola Exhibición</Option>
                              <Option value={2}>PPD - Pago en Parcialidades o Diferido</Option>
                            </SelectItem>
                          </FormItem>
                          <FormItem noStyle shouldUpdate={(prev, curr) => prev.metodoPago !== curr.metodoPago}>
                            {({ getFieldValue }) => {
                              const metodoPago = getFieldValue("metodoPago");
                              const todas = this.state.todasFormasDePago || [];
                              let filtradas = todas;
                              if (metodoPago === 2) filtradas = todas.filter(v => v.c_FormaPago === 99);
                              else if (metodoPago === 1) filtradas = todas.filter(v => v.c_FormaPago !== 99);
                              return (
                                <FormItem name="formaDePagoId" label="Forma de Pago" margin>
                                  <SelectItem placeholder="Forma de Pago" allowClear>
                                    {filtradas.map(v => (
                                      <Option value={v._id} key={v._id}>
                                        {v.c_FormaPago + " - " + v.descripcion}
                                      </Option>
                                    ))}
                                  </SelectItem>
                                </FormItem>
                              );
                            }}
                          </FormItem>
                        </Col>
                        <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                          <FormItem label="Proveedor" name="proveedorId" margin required>
                            <SelectItem
                              disabled={this.state.requisicion}
                              placeholder="Proveedor"
                              onChange={this.onChangeProveedor.bind(this)}
                            >
                              {this.state.objetoProveedores}
                            </SelectItem>
                          </FormItem>
                          {this.state.proveedorId && (
                            <Row justify="center">
                              <Tooltip title="Asignar un nuevo insumo al proveedor seleccionado.">
                                <ButtonItem
                                  style={{ marginTop: 10, marginBottom: 10, width: "auto" }}
                                  type="primary"
                                  onClick={this.abrirModalAsignarInsumo}
                                  block
                                  cyan
                                  hotkey="alt+n"
                                  icon={<PlusOutlined />}
                                >
                                  Asignar Nuevo Insumo
                                </ButtonItem>
                              </Tooltip>
                            </Row>
                          )}
                          <FormItem label="Fecha Entrega" name="fechaEntrega" margin>
                            <DatePickerItem placeholder="Fecha de Entrega" />
                          </FormItem>
                          <FormItem label="Cotización" name="cotizacionOC" margin>
                            <InputItem placeholder="Cotización" />
                          </FormItem>
                        </Col>
                      </Row>
                    ),
                  },
                  {
                    title: "Moneda",
                    lg: 6,
                    content: (
                      <>
                        <FormItem
                          required
                          margin
                          name="monedaId"
                          label="Moneda"
                          labelCol={{ span: 8 }}
                          wrapperCol={{ span: 16 }}
                          initialValue="60c7e4396465ad440c41c15a"
                        >
                          <SelectItem
                            onChange={(value) => this.aplicarMoneda(value)}
                            placeholder="Moneda"
                          >
                            {this.state.objetoMonedas}
                          </SelectItem>
                        </FormItem>
                        <FormItem noStyle shouldUpdate={(prev, curr) => prev.monedaId !== curr.monedaId}>
                          {({ getFieldValue }) => {
                            const monedaId = getFieldValue("monedaId");
                            return monedaId !== "60c7e4396465ad440c41c15a" ? (
                              <FormItem
                                required
                                number
                                margin
                                label="T. Cambio"
                                name="tipoDeCambio"
                                type="number"
                                initialValue={1}
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                              >
                                <InputNumberItem
                                  dinero
                                  placeholder="T. Cambio"
                                />
                              </FormItem>
                            ) : (
                              <FormItem name="tipoDeCambio" initialValue={1} hidden>
                                <InputNumberItem />
                              </FormItem>
                            );
                          }}
                        </FormItem>
                      </>
                    ),
                  },
                ]}
                tabsConfig={{
                  tabs: [
                    {
                      key: "insumos",
                      label: "Insumos",
                      listName: "insumos",
                      columns: this.getInsumosColumns(),
                      renderRow: this.renderInsumoRow,
                      renderHeader: () => (
                        <Row justify="end" style={{ marginBottom: "10px", marginRight: "15px" }} gutter={8}>
                           <Col span={10}>
                            <Input.Search
                              prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
                              placeholder="Buscar por descripción, código, clave o cód. barras..."
                              allowClear
                              enterButton={
                                <Button
                                  type="primary"
                                  style={{
                                    background: "#00BFD6",
                                    borderColor: "#00BFD6"
                                  }}
                                >
                                  Buscar
                                </Button>
                              }
                              size="middle"
                              onSearch={this.buscarInsumo}
                              onChange={(e) => {
                                if (!e.target.value) this.setState({ insumoResaltado: null });
                              }}
                              style={{ borderRadius: 8 }}
                            />
                          </Col>
                     
                            <Space>
                              <Typography.Text style={{ fontSize: "12px", color: "#888" }}>
                                Mostrar detalles:
                              </Typography.Text>
                              <Switch
                                size="small"
                                checked={this.state.mostrarDetalles}
                                onChange={(checked) => this.setState({ mostrarDetalles: checked })}
                              />
                            </Space>
                            <Space>
                              <Typography.Text style={{ fontSize: "12px", color: "#888" }}>
                                Ver como sistema:
                              </Typography.Text>
                              <Switch
                                size="small"
                                checked={this.state.verInsumosComoSistema}
                                onChange={(checked) => this.setState({ verInsumosComoSistema: checked })}
                              />
                            </Space>
                            <Space style={{ marginLeft: 16 }}>
                              <Typography.Text style={{ fontSize: "12px", color: "#888" }}>
                                Agrupar por familia:
                              </Typography.Text>
                              <Switch
                                size="small"
                                checked={this.state.agruparPorFamilia}
                                onChange={(checked) => this.setState({ agruparPorFamilia: checked })}
                              />
                            </Space>

                        </Row>
                      ),
                      agrupacion: this.agrupacionPorFamilia(),
                      renderFooter: ({ add, fields }) => (
                        <FormItem noStyle>
                          <ButtonItem
                            style={{
                              marginTop: 10,
                              marginBottom: 10,
                              justifySelf: fields.length > 0 ? "left" : null,
                              width: fields.length > 0 ? "auto" : null,
                            }}
                            type="primary"
                            onClick={() =>
                              this.autoGuardarYAgregar(add, {
                                insumoSinRequisicion: this.state.requisicion
                              })
                            }
                            block
                            hotkey="alt+a"
                            icon={<PlusOutlined />}
                            cyan
                          >
                            Agregar Insumo
                          </ButtonItem>
                        </FormItem>
                      ),
                    },
                  ],
                }}
                observacionesConfig={{
                  observaciones: {
                    value: this.formRef.current?.getFieldValue("observaciones"),
                    onSave: (newValue) => {
                      this.formRef.current?.setFieldsValue({ observaciones: newValue });
                      this.forceUpdate();
                    },
                  },
                  observaciones2: {
                    label: "Observaciones Internas",
                    tooltip: "Estas observaciones no se imprimirán.",
                    value: this.formRef.current?.getFieldValue("observaciones2"),
                    onSave: (newValue) => {
                      this.formRef.current?.setFieldsValue({ observaciones2: newValue });
                      this.forceUpdate();
                    },
                  },
                  ...this.getObservacionesConfig(),
                }}
                actionButtons={
                  this.state.modificadaRequisicion ? (
                    <Space wrap>
                      <Popconfirm
                        title="No se regresaran los insumos a la requisicion, estas seguro?"
                        onConfirm={this.noModificarRequisicion.bind(this)}
                        okText="Si"
                        cancelText="No"
                      >
                        <ButtonItem type="primary" blanco={true}>
                          No Modificar Requisicion
                        </ButtonItem>
                      </Popconfirm>
                      <Popconfirm
                        title="Se regresaran los insumos a la requisicion"
                        onConfirm={this.modificarRequisicion.bind(this)}
                        okText="Si"
                        cancelText="No"
                      >
                        <ButtonItem>Modificar Requisicion</ButtonItem>
                      </Popconfirm>
                    </Space>
                  ) : (
                    <Space>
                      {this.props.autorizacionesRapidas && (
                        <Tooltip title="Si no puedes aprobar la orden tú mismo, se enviará sola una solicitud a los autorizadores configurados en cuanto se guarde.">
                          <Checkbox
                            checked={this.state.enviarAprobacionAutomatica}
                            onChange={(e) => this.setState({ enviarAprobacionAutomatica: e.target.checked })}
                          >
                            <span style={{ fontSize: "12px", color: "#888" }}>
                              Enviar automáticamente a aprobación
                            </span>
                          </Checkbox>
                        </Tooltip>
                      )}
                      <ButtonItem type="primary" hotkey="alt+e" htmlType="submit" cyanB>
                        Editar
                      </ButtonItem>
                    </Space>
                  )
                }
              />
              <FormItem name="observaciones" hidden><TextAreaItem /></FormItem>
              <FormItem name="observaciones2" hidden><TextAreaItem /></FormItem>
            </Form>
          </Spin>
        </div>
        <ElegirTipoDeProveedor
          visible={this.state.modalElegirTipoDeProveedor}
          id={this.state.modalElegirTipoDeProveedorId}
          nombre={this.state.modalElegirTipoDeProveedorNombre}
          cerrarElegirTipoDeProveedor={this.cerrarElegirTipoDeProveedor.bind(
            this
          )}
        />
        <ElegirObservaciones
          visible={this.state.modalObservaciones}
          cerrarElegirObservaciones={this.cerrarObservaciones.bind(this)}
          observaciones={this.state.modalObservacionesObservaciones}
          observacionesPasadas={
            this.state.modalObservacionesObservacionesPasadas
          }
          observacionesXml={this.state.modalObservacionesObservacionesXml}
          noXml
          proveedorIdActual={this.state.proveedorIdActual} 
          nombreProveedorActual={this.state.nombreProveedorActual}
        />
        <AsignarInsumo
          visible={this.state.modalAsignarInsumoVisible}
          cerrarAsignarInsumo={this.cerrarModalAsignarInsumo}
          proveedor={this.state.proveedorSeleccionado} // <-- Le pasas el proveedor completo
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
        />
        <ModalVerRequisicion
          visible={this.state.modalVerRequisicion}
          requisicionId={this.state.modalVerRequisicionId}
          onClose={this.cerrarModalVerRequisicion.bind(this)}
          cerrarModalVerRequisicion={this.cerrarModalVerRequisicion.bind(this)}
        />
        <ModalItem
          visible={this.state.modalPdfSeparar}
          onCancel={this.cerrarModalPdfSeparar}
          spinning={false}
          title="PDF Separación de Insumos"
          footer={null}
          width="85vw"
          style={{ top: 20 }}
          destroyOnClose
        >
          {this.state.pdfSepararUrl ? (
            <iframe
              title="PDF Separación"
              src={this.state.pdfSepararUrl}
              style={{ width: "100%", height: "80vh", border: "none" }}
            />
          ) : null}
        </ModalItem>
        <DisponibilidadInsumoModal
          visible={this.state.modalDisponibilidadVisible}
          onClose={this.cerrarDisponibilidad}
          insumoId={this.state.insumoSeleccionadoDisponibilidad.id}
          nombreInsumo={this.state.insumoSeleccionadoDisponibilidad.nombre}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
          proyectoId={this.state.insumoSeleccionadoDisponibilidad.proyectoId}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    autorizacionesRapidas: state.empresa.autorizacionesRapidas,
    verComoSistemaOCPorDefecto: state.empresa.verComoSistemaOCPorDefecto,
    separacionInsumosSimpleOC: state.empresa.separacionInsumosSimpleOC,
    separacionInsumosPorClienteOC: state.empresa.separacionInsumosPorClienteOC,
    separacionInsumosPorDiaOC: state.empresa.separacionInsumosPorDiaOC,
    escuela: state.empresa.escuela,
  };
};

export default connect(mapStateToProps)(EditarOrdenDeCompra);
